import React, { memo } from "react";
import "./index.css";

export const BlankSpace = memo(() => <span className="blank-space"> </span>);
